import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "랜딩 URL 카테고리", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "----", -1)
const _hoisted_11 = {
  key: 0,
  class: "form-group"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "--선택하세요--", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "일부 발송(uid, 닉네임, 실명, 이메일)", -1)
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", null, "테스트 발송 여부", -1)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "발송", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")

  return (_openBlock(), _createBlock("div", {
    class: ["card", { loading: _ctx.loading }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.push.title = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.push.title]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode("textarea", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.push.body = $event))
          }, null, 512), [
            [_vModelText, _ctx.push.body]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_file_upload, {
              ref: "thumbnailFile",
              "set-preview-img": _ctx.setPreviewImg,
              "folder-name": 'app-push'
            }, null, 8, ["set-preview-img"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCategory = $event)),
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSelectionChange && _ctx.handleSelectionChange(...args)))
          }, [
            _hoisted_10,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.landingUrlList, (value) => {
              return (_openBlock(), _createBlock("option", {
                key: value,
                value: value
              }, _toDisplayString(value), 9, ["value"]))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedCategory]
          ])
        ]),
        (Object.keys(_ctx.landingUrlOption).length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("label", null, _toDisplayString(_ctx.selectedCategory) + " 리스트", 1),
              _withDirectives(_createVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedLandingUrl = $event)),
                required: ""
              }, [
                _hoisted_12,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.landingUrlOption, (value, label) => {
                  return (_openBlock(), _createBlock("option", {
                    key: value,
                    value: value
                  }, _toDisplayString(label), 9, ["value"]))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedLandingUrl]
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.push.keywords = $event))
          }, null, 512), [
            [_vModelText, _ctx.push.keywords]
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _createVNode("label", _hoisted_18, [
              _withDirectives(_createVNode("input", {
                type: "checkbox",
                class: "c-switch-input",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.push.dry_run = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.push.dry_run]
              ]),
              _hoisted_19
            ])
          ])
        ]),
        _hoisted_20
      ], 32)
    ])
  ], 2))
}